/**
  Update FAQ 'Does this cane come with a tip'question
  implemented: snippets/product-page-get-main.liquid, snippets/product-page-get-main-clear-stix.liquid
*/
document.addEventListener("DOMContentLoaded", function () {
  
  const scriptVariantsData = document.querySelector("script#tip-meta-data").innerHTML
  const variantsData = JSON.parse(scriptVariantsData);
  console.log( "tip data", variantsData);

  const tip_el = document.querySelector('[ data-js-product-tip-size]')
  if(!tip_el){
    return console.log("Cant find DOM element for tip size")
  }

  //main product with tip size
  if(variantsData['main-product'].tip_size !== 'null'){
     tip_el.innerHTML = `Yes, this cane comes with a <strong >${variantsData['main-product'].tip_size} mm tip</strong>.`
     return console.log("main tip size with number", variantsData['main-product'].tip_size ) 
  }

  const main_sku = variantsData['main-product'].sku
  const variant_sku =  variantsData[main_sku]
  console.log("variant sku", variant_sku)

  // variant with tip size
  if(variant_sku.tip_size !== 'null'){
     tip_el.innerHTML = `Yes, this cane comes with a <strong >${variant_sku.tip_size} mm tip</strong>.`
     return console.log("variant tip size with number", variant_sku.tip_size ) 
  }

  // variant without tip size
  tip_el.innerText = `No, this cane comes without a tip.`
  
})